module.exports = __webpack_public_path__ + "96bea3222d1cd96f36ff3fbce683f0fb.svg";